module.exports = __webpack_public_path__ + "img/team-member-04.c602b6ff.jpg";